export const SERVICE_HOURS_MESSAGE = "Indiquez l'heure de début et de fin de service";

function filled(value) {
  return String(value || '').trim();
}

function euroDate(value) {
  const match = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(String(value || '').trim());
  if (!match) return null;
  const date = new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
  if (Number.isNaN(date.getTime())) return null;
  if (date.getDate() !== Number(match[1]) || date.getMonth() !== Number(match[2]) - 1) return null;
  return date;
}

export function nextCalendarDate(value) {
  const date = euroDate(value);
  if (!date) return value;
  date.setDate(date.getDate() + 1);
  const pad = (part) => String(part).padStart(2, '0');
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
}

/** Date de fin du lendemain quand le service passe minuit et que la fin n'est pas déjà après le début. */
export function endDateForNight(dateStart, dateEnd, shiftStart, shiftEnd) {
  const start = String(shiftStart || '');
  const end = String(shiftEnd || '');
  if (!/^\d{2}:\d{2}$/.test(start) || !/^\d{2}:\d{2}$/.test(end) || end >= start) {
    return dateEnd;
  }
  const startDate = euroDate(dateStart);
  const endDate = euroDate(dateEnd);
  if (!startDate) return dateEnd;
  if (!endDate || endDate.getTime() <= startDate.getTime()) return nextCalendarDate(dateStart);
  return dateEnd;
}

/** Null when both service hours are present. Otherwise the message and the empty field. */
export function serviceHoursIssue(form) {
  const start = filled(form?.shift_start);
  const end = filled(form?.shift_end);
  if (start && end) return null;
  return {
    message: SERVICE_HOURS_MESSAGE,
    fieldId: start ? 'shift-end' : 'shift-start',
  };
}
